import { formatNumber, formatPrice } from "../../utils/utility"
import Heading from "../common/heading"
import styles from "./loan-payment-detail.module.scss"

const LoanPaymentDetail = ({ data }) => {
  const { propertyPrice, years, interestRate, downPayment } = data
  let calculatedValue = 0
  let loanAmout = (propertyPrice * (100 - parseInt(downPayment))) / 100
  let interest = interestRate / 100 / 12

  calculatedValue = (interest * Math.pow(1 + interest, years * 12)) / (Math.pow(1 + interest, years * 12) - 1)
  calculatedValue = calculatedValue * loanAmout

  let totalPayable = calculatedValue * 12 * parseInt(years)
  let totalinterestPayable = totalPayable - loanAmout
  let principleWeight = (loanAmout / totalPayable) * 100
  let interestWeight = (totalinterestPayable / totalPayable) * 100

  return (
    <>
      <Heading variant="h2">Payment Details</Heading>
      <div className={`${styles.loanCalculation} flex u-mb32`}>
        <div className={`${styles.priceInstallment} u-spbwy16`}>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Property Price:</div>
            <div className={styles.price}>
              <span className={`${styles.unit} ${styles.fontWeightBold}`}>PKR</span>
              <span className={`${styles.totalPrice} ${styles.fontWeightBold}`} id="result_property_price_lang">
                {formatPrice(propertyPrice)}
              </span>
              <span className={styles.currency} id="result_property_price">
                {`(${formatNumber(data?.propertyPrice)})`}
              </span>
            </div>
          </div>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Down Payment:</div>
            <div className={styles.price}>
              <span className={`${styles.unit} ${styles.fontWeightBold}`}>PKR </span>
              <span className={`${styles.totalPrice} ${styles.fontWeightBold}`} id="result_downpayment_lang">
                {formatPrice((propertyPrice * downPayment) / 100)}
              </span>
              <span className={styles.currency} id="result_downpayment">
                {`(${formatNumber((propertyPrice * downPayment) / 100)}, ${downPayment} %)`}
              </span>
            </div>
          </div>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Loan Amount:</div>
            <div className={styles.price}>
              <span className={`${styles.unit} ${styles.fontWeightBold}`}>PKR </span>
              <span className={`${styles.totalPrice} ${styles.fontWeightBold}`} id="loan_amount_text">
                {formatPrice(loanAmout)}
              </span>
              <span className={styles.currency} id="loan_amount">
                {formatNumber(loanAmout)}
              </span>
            </div>
          </div>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Period:</div>
            <div className={styles.price}>
              <span className={`${styles.totalPrice} ${styles.fontWeightBold}`} id="period_text">
                {years} years
              </span>
            </div>
          </div>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Interest Rate:</div>
            <div className={styles.price}>
              <span className={`${styles.totalPrice} ${styles.fontWeightBold}`} id="result_interest">
                {interestRate}%
              </span>
            </div>
          </div>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Monthly Payment:</div>
            <div className={styles.price}>
              <span className={`${styles.unit} ${styles.fontWeightBold}`}>PKR </span>
              <span className={`${styles.totalPrice} ${styles.fontWeightBold}`} id="monthly_payment_lang">
                {formatPrice(Math.round(calculatedValue))}
              </span>
              <span className={styles.currency} id="monthly_payment">
                ({formatNumber(Math.round(calculatedValue))})
              </span>
            </div>
          </div>
          <div className={`${styles.paymentInfo} flex`}>
            <div className={styles.label}>Payment Breakdown:</div>
            <div className={styles.price}>
              <div className={`${styles.paymentBreakdown} u-mb4 flex`}>
                <div
                  className={`${styles.active} ${styles.item} inlineFlex flexYcenter flexXcenter`}
                  style={{ width: Math.round(interestWeight) + "%" }}
                  id="mortgage_interest_bar"
                >
                  {Math.round(interestWeight)}%
                </div>
                <div
                  className={`${styles.principle} ${styles.item} inlineFlex flexYcenter flexXcenter`}
                  style={{ width: Math.round(principleWeight) + "%" }}
                  id="mortgage_principle_bar"
                >
                  {Math.round(principleWeight)}%
                </div>
              </div>
              <div className={`${styles.paymentLabel} flex flexBetween`}>
                <div className={styles.item}>Interest</div>
                <div className={styles.item}>Principal</div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.totalInstallment}`}>
          <div className={`${styles.totalInstallmentDes} ${styles.pRalative} u-mb32`}>
            <div className={`${styles.plan} ${styles.fontWeightBold} u-mb8`}>Monthly Installment</div>
            <div className={`${styles.totalPrice} ${styles.fontWeightBold} u-mb4`} id="mortage_monthly_text">
              <span className={styles.unit}>PKR</span>
              <span id="mortage_monthly_text_span">{formatPrice(Math.round(calculatedValue))}</span>
            </div>
            <div className={`${styles.price} ${styles.fontWeightBold}`}>
              <span className={styles.unit}>PKR</span>
              <span id="mortage_monthly">{formatNumber(Math.round(calculatedValue))}</span>
            </div>
          </div>
          <hr className={`${styles.line} u-mb24`} />
          <div className={`${styles.totalInstallmentDes} ${styles.pRalative}`}>
            <div className={`${styles.plan} ${styles.fontWeightBold} u-mb8`}>Loan Amount</div>
            <div className={`${styles.totalPrice} ${styles.fontWeightBold} u-mb4`} id="mortgage_loan_txt">
              <span className={styles.unit}>PKR</span>
              <span id="mortgage_loan_txt_span">{formatPrice(loanAmout)}</span>
            </div>
            <div className={`${styles.price} ${styles.fontWeightBold}`}>
              <span className={styles.unit}>PKR</span>
              <span id="mortage_loan_amount">{formatNumber(loanAmout)}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoanPaymentDetail
